import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ProgressModal from "../../utility/ProgressModal";
import MultimediaContainer from "../../components/EntertainmentEntityManagement/CreateUpdateMultimediaAndQuesEE/MultimediaContainer";
import api_service from "../../network/api_callbacks";
import { toast } from "react-toastify";

const entityData = {
    "_id": "6894a16b7d940a01c01277ed",
    "type": "movie",
    "displayName": "Sooryavansham",
    "metadata": {
        "year": 1999,
        "language": "hi",
        "country": "in",
        "artists": [
            "689499e84b8c8a96ef513416"
        ],
        "industry": [
            "bollywood"
        ],
        "released": "21May1999"
    },
    "multimedia": [
        {
            "mediaType": "video",
            "url": "https://api.vimeo.com/videos/1108090823",
            "aspectRatio": "16:9"
        },
        {
            "mediaType": "image",
            "imageType": "thumbnail",
            "url": "https://d3oxgt44kg2k0d.cloudfront.net/ap-south-1%3A64038f50-13d3-cf2a-9102-fab5a61c8c2e/entertainment_entity/Sooryavansham.jpg",
            "aspectRatio": "2:3"
        },
        {
            "mediaType": "audio",
            "url": "https://d3oxgt44kg2k0d.cloudfront.net/ap-south-1%3A64038f50-13d3-cf2a-9102-fab5a61c8c2e/entertainment_entity/SampleAudio_0.4mb.mp3"
        }
    ],
    "tags": [
        {
            "type": "movie_genre",
            "details": {
                "genreName": "drama"
            }
        },
        {
            "type": "movie_genre",
            "details": {
                "genreName": "family"
            }
        }
    ],
    "created_at": "2025-08-07T12:51:55.950Z",
    "updated_at": "2025-08-18T04:47:53.719Z",
    "__v": 0
}

const CreateMultimediaEntity = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state;

    const [editableMultimediaData, setEditableMultimediaData] = useState(null);
    const [multimediaData, setMultimediaData] = useState(null);
    const [selectedItemIndex, setSelectedItemIndex] = useState(null);
    const [entertainment_entity_filter, setEntertainment_entity_filter] = useState(null);
    const [artists, setArtists] = useState([]);
    const [action, setAction] = useState(null);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        if (!editableMultimediaData && state?.entity_data) {
            //console.log("entity_data : ", state?.entity_data);
            //console.log("multimedia : ", state?.multimedia);
            //console.log("entertainment_entity_filter : ", state?.entertainment_entity_filter);
            setEditableMultimediaData(state?.entity_data);

            const entity_artist =
            {
                "_id": "6891d60a0ad9f6069e94d83d",
                "type": "artist",
                "displayName": "Arijit",
                "multimedia": [
                    {
                        "mediaType": "image",
                        "imageType": "avatar",
                        "url": "https://picsum.photos/seed/picsum/200/200",
                        "aspectRatio": "1:1"
                    },
                    {
                        "mediaType": "image",
                        "imageType": "thumbnail",
                        "url": "https://fastly.picsum.photos/id/382/200/200.jpg?grayscale&hmac=nRBLVgtebwvxOK2CtQnJIkuQiIAiJkXpiSG_GrdIsg4",
                        "aspectRatio": "3:4"
                    },
                    {
                        "mediaType": "image",
                        "imageType": "banner",
                        "url": "https://picsum.photos/id/237/200/200",
                        "aspectRatio": "1:2"
                    }
                ],
                "tags": [
                    {
                        "type": "songGenre",
                        "details": {
                            "genreName": "action"
                        }
                    }
                ],
                "metadata": {
                    "artists": [

                    ],
                    "artistType": "singer",
                    "isSuperStar": false,
                    "industry": [
                        "bollywood"
                    ]
                },
                "created_at": "2025-08-05T09:59:38.218Z",
                "updated_at": "2025-08-05T09:59:38.218Z",
                "__v": 0
            }

            const entity_song =
            {
                "type": "song",
                "displayName": "WavesofSilence",
                "multimedia": [
                    {
                        "mediaType": "image",
                        "imageType": "thumbnail",
                        "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/actor+photo/gulam.png",
                        "aspectRatio": "16: 9"
                    }
                ],
                "tags": [
                    {
                        "type": "songGenre",
                        "details": {
                            "genreName": "action",
                            "_id": "68908bb445b4d085eba1f39b"
                        }
                    }
                ],
                "metadata": {
                    "year": 2024,
                    "duration": 228,
                    "label": "SaReGaMAIndiaLtd",
                    "language": "hi",
                    "country": "in",
                    "industry": "tollywood_telugu",
                    "artistType": "singer",
                    "artists": ["6890955131f40a8148e58b83"]
                }
            }

            const entity_movie =
            {
                "type": "movie",
                "displayName": "WavesofSilence",
                "multimedia": [
                    {
                        "mediaType": "image",
                        "imageType": "thumbnail",
                        "url": "https://image-bucket-nexiantian.s3.ap-south-1.amazonaws.com/actor+photo/gulam.png",
                        "aspectRatio": "16: 9"
                    }
                ],
                "tags": [
                    {
                        "type": "movie_genre",
                        "details": {
                            "genreName": "action",
                            "_id": "68908bb445b4d085eba1f39b"
                        }
                    },
                    {
                        "type": "movie_genre",
                        "details": {
                            "genreName": "romance",
                            "_id": "68908bb445b4d085eba1f39b"
                        }
                    }
                ],
                "metadata": {
                    "language": "hi",
                    "country": "in",
                    "industry": "tollywood_telugu",
                    "artistType": "singer",
                    "year": 2024,
                    "released": "24Aug2014",
                    "plot": "SaReGaMAIndiaLtd",
                    "duration": 228,
                    "artists": ["689339213bc9140733a76482"]
                }
            }
            //setEditableEntityData(entity_movie);
        }
        if (!multimediaData && state?.multimedia) {
            setMultimediaData(state?.multimedia);
        }
        if (!editableMultimediaData && state?.index) {
            setSelectedItemIndex(state?.index);
        }
        if (!entertainment_entity_filter && state?.entertainment_entity_filter) {
            setEntertainment_entity_filter(state?.entertainment_entity_filter);
        }
        if (state?.artists) {
            setArtists(state?.artists);
        }
    }, [editableMultimediaData, state?.entity_data, state?.multimedia, state?.artists, state?.entertainment_entity_filter]);

    const handleBackToCreateUpdateEntityManagement = (isReferesh, actionData) => {
        console.log("handleBackToCreateUpdateEntityManagement : ", actionData);
        setAction(null);
        navigate('/entertainment-entity-management/create-entertainment-entity', {
            state: {
                from: 'create-multimedia-entity',
                entity_data: editableMultimediaData,
                entertainment_entity_filter: entertainment_entity_filter,
                actionData: actionData,
                shouldRefresh: isReferesh,
            }
        });

       // navigate("..", { replace: true });
    };

    const showLoader = (show) => {
        console.log("showLoader : ", show);
        if (!loader) {
            setLoader(!loader);
        }
    }

    const isValidate = (action, editableEntityData) => {
        if (action === 'delete') {

        } else if (action === 'create') {

        } else if (action === 'update') {

        }
        return true;
    }

    const editMultimediaApi = async () => {
        //console.log("editMultimediaApi - multimediaData : ", multimediaData);
        try {
            const requestPayload = {
                ...(Array.isArray(multimediaData?.entity) && multimediaData.entity.length > 0
                    ? { entity: multimediaData.entity }
                    : { entity: [] }),
                ...(multimediaData?.metadata && { metadata: multimediaData.metadata })
            }
            const response = await api_service.editMultiMedia(multimediaData?._id, requestPayload);
            //console.log('📘 Multimedia response Data:', response);
            if (response) {
                toast.success('Multimedia updated successfully!');
                handleBackToCreateUpdateEntityManagement(true, response);
            }
            else {
                toast.error('Failed to update Multimedia. Please try again.');
            }
        } catch (error) {
            console.error('❌ Failed to fetch Multimedia:', error);
        }
    }

    const deleteMultimediaApi = async () => {
        try {
            const response = await api_service.deleteMultiMedia(multimediaData?._id);
            //console.log('📘 Multimedia Data:', response);
            if (response) {
                toast.success('Multimedia deleted successfully!');
                handleBackToCreateUpdateEntityManagement(true, response);
            }
            else {
                toast.error('Failed to delete Multimedia. Please try again.');
            }
        } catch (error) {
            console.error('❌ Failed to fetch Multimedia:', error);
        }
    }

    const callApis = (action, editableEntityData) => {
        //console.log("action api => ", editableEntityData?._id)
        //console.log("multimedia => ", multimediaData)
        if (action === 'delete') {
            //props?.deleteEntity(editableEntityData?._id);
            deleteMultimediaApi();
        } else if (action === 'create') {

        } else if (action === 'update') {
            editMultimediaApi();
        }
    }

    const handleMultimediaCTAButtonsClick = (action) => {
        setAction(action);
        if (action === 'delete') {
            const isValid = isValidate(action, editableMultimediaData)
            if (isValid) {
                callApis(action, editableMultimediaData);
            }
        } else if (action === 'create') {
            const isValid = isValidate(action, editableMultimediaData)
            if (isValid) {
                callApis(action, editableMultimediaData);
            }
        } else if (action === 'update') {
            const isValid = isValidate(action, editableMultimediaData)
            if (isValid) {
                callApis(action, editableMultimediaData);
            }
        }
    }

    return (
        <>
            <div style={{
                flex: 1,
                marginTop: '30px',
                marginLeft: '0px',
                padding: '0px 0px 0px 0px',
                textAlign: 'center',
                width: '100%',
                height: '100%',
            }}>
                <MultimediaContainer
                    editableMultimediaData={editableMultimediaData}
                    setEditableMultimediaData={setEditableMultimediaData}
                    multimediaData={multimediaData}
                    setMultimediaData={setMultimediaData}
                    showLoader={showLoader}
                    entertainment_entity_filter={entertainment_entity_filter}
                    artists={artists}
                    handleMultimediaCTAButtonsClick={handleMultimediaCTAButtonsClick}
                />
            </div>
            {(loader) && <ProgressModal open={loader} isLoader={loader} progress={0} title="Progress..." />}
        </>
    )
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(CreateMultimediaEntity)